import React, { useContext, useEffect, useState } from 'react';

import { ServiceResponse } from '../../../app/services/shared/interfaces';
import LazyLoading from '../../../components/LazyLoading';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { toast } from 'react-toastify';
import useItemCategoryService from '../../../app/services/hooks/useItemCategoryService';
import { ItemCategory } from '../../../app/models/ItemCategory';
import ItemCategoryFormContainer from './ItemCategoryFormContainer';


interface Props {
    itemCategoryId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const ItemCategoryEdit = ({ itemCategoryId, onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const { fetchingEditItemCategory, editItemCategory, fetchingUpdateItemCategory, updateItemCategory } =
        useItemCategoryService();

    const [itemCategory, setItemCategory] = useState<ItemCategory>({ name: '' });
    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        edit();
    }, []);

    const edit = () => {
        if (showLoading) showLoading('loading', 'Cargando categoría...');
        editItemCategory(itemCategoryId, {
            onSuccess: (response: ServiceResponse) => {
                setItemCategory(response.data.item_category);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };

    const update = () => {
        if (showLoading) showLoading('loading', 'Actualizando categoría...');
        updateItemCategory(itemCategoryId, itemCategory, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingEditItemCategory ? (
        <LazyLoading height="300" />
    ) : (
        <ItemCategoryFormContainer
            fetching={fetchingUpdateItemCategory}
            action={update}
            cancel={cancel}
            itemCategory={itemCategory}
            setItemCategory={setItemCategory}
            errorFields={errorFields}
        />
    );
};

export default ItemCategoryEdit;
